
import Vue from 'vue'

export default Vue.extend({
  name: 'CommonImg',
  props: [
    'type',
    'src',
    'srcset',
    'sizes',
    'alt',
    'width',
    'height',
    'cssClass',
    'contain',
    'loading',
    'format',
    // nuxt-img
    'fit',
    'quality',
    'modifiers',
  ],
  computed: {
    computedCssClass() {
      return this.cssClass || ''
    },
    computedSrc() {
      return this.src?.replace(this.$config.wpBaseURL, '')
    },
  },
})
